import React, { useEffect, useState, } from 'react';
import { ToggleButton, ToggleButtonGroup, Grid, Box, Typography, Button, IconButton, Tooltip, Badge, InputLabel, FormControl, Select, MenuItem } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { styled } from "@mui/material/styles";
import { student as studentConstant } from './constants';
// import studentJson from "../../assets/static/student-list.json"

import { useTheme } from '@mui/material/styles';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GridViewIcon from '@mui/icons-material/GridView';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Link from '@mui/material/Link';

import { ClockCountdown } from "@phosphor-icons/react/dist/ssr";
import StudentCard from '../../components/student/Card';
import { NoStudent } from '../../components/student/NoStudent';
import { useStudent } from './hooks';
import { getProfileInfo } from '../../store/profile/profileBaseAPi';
import { Newspaper, ReadCvLogo, SignIn, TrendUp } from '@phosphor-icons/react';
import Loader from '../../components/Loader';


const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
    padding: theme.spacing(1),
    height: '30px',
    border: 'none',
    '&.Mui-selected': {
        background: 'transparent',
        '& .MuiSvgIcon-root': {
            color: 'var(--mui-palette-primary-orange)',
        },
    },
}));




export const Student = () => {
    const { students, loadStudents, loadTeacherGrades, teacherGrades, loading } = useStudent();
    const theme = useTheme();
    const [view, setView] = useState('card');
    const [studentList, setStudentList] = useState([]);
    const [gradeList, setGradeList] = useState([]);
    const [selectedGrade, setSelectedGrade] = useState();
    const [selectedSection, setSelectedSection] = useState();
    const [sectionList, setSectionList] = useState([]);
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'));
    const [filterData, setFilterData] = useState()
    const [teacherDetails, setTeacherDetails] = useState();
    // not need

    const columns = [
        { field: 'firstName', headerName: 'First Name', flex: 1 },
        { field: 'lastName', headerName: 'Last Name', flex: 1 },
        {
            field: 'grade', headerName: 'Grade', flex: 1,
        },
        {
            field: 'section', headerName: 'Section', flex: 1,
        },
        { field: 'gradeLevel', headerName: 'Level', flex: 1 },
        {
            field: 'activity',
            headerName: 'Activity',
            width: 150,
            renderCell: (params) => (
                <strong>
                    <IconButton disabled={!params.row.irStatus}>
                           <Link component={RouterLink} to={`/student/activity/${params.row.id}`} title="Student Activity" sx={{
                            color: params.row.irStatus ? '' : 'grey'
                        }}>
                            <TrendUp size={22} sx={{ color: 'var(--mui-palette-primary-button)', fontSize: '1.2rem' }} />
                        </Link>
                    </IconButton>
                </strong>
            ),
        },
        {
            field: 'actions',
            headerName: 'Details',
            width: 150,
            renderCell: (params) => (
                <strong>
                    <IconButton>
                           <Link component={RouterLink} to={`/student/edit/${params.row.id}`} title="Student Details">
                            <Newspaper size={22} sx={{ color: 'var(--mui-palette-primary-button)', fontSize: '1.2rem' }} />
                        </Link>
                    </IconButton>
                </strong>
            ),
        },
    ];

    useEffect(async () => {
        let { data } = await getProfileInfo({
            payload: { username: user.userName, roles: user.roles[0].role }
        });
        // loadStudents({ teacherId: data?.teacher?.id });
        loadStudents({ teacherId: data?.teacher?.id, schoolId: data?.teacher?.school, branchId: data?.teacher?.branch });
        loadTeacherGrades({ teacherId: data?.teacher?.id, menuName: "TEACH" })
        setTeacherDetails(data?.teacher)
        // not need

    }, []);
    useEffect(() => {
        // let studentFilter = students.filter(data => data?.diagnosticTest)
        let studentFilter = students
        setStudentList(studentFilter);
        setGradeList(teacherGrades);

    }, [students, teacherDetails, teacherGrades])

    const handleViewChange = (event, newView) => {
        if (newView !== null) {
            setView(newView);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilterData(prevData => ({
            ...prevData,
            [name]: value,
        }));
    }

    const handleGradeChange = (e) => {
        const { name, value } = e.target;
        setSectionList(value?.sections || [])
        setSelectedGrade(value);
    }

    const handleSectionChange = (e) => {
        const { name, value } = e.target;
        setSelectedSection(value);
    }

    const getFilteredStudents = () => {
        return studentList?.filter(student => {
            return (
                (!selectedGrade?.grade || student?.grade === selectedGrade?.grade)
                &&
                (!selectedSection?.section || student?.section === selectedSection?.section)
                &&
                (!filterData?.irLevel || student?.gradeLevel === filterData?.irLevel)
            )
        })

    }
    return (
        <>{loading ? <Loader /> :
            <div>
                <div className='course'>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}>
                        <Typography
                            align="left"
                            variant="h1"
                            color="primary.blue"
                            sx={{
                                margin: '0',
                                fontWeight: '700',
                                lineHeight: '1.5',
                                fontSize: '1.8rem',
                            }}>Student</Typography>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                [theme.breakpoints.down('sm')]: {
                                    flexDirection: 'row',
                                },
                            }}>
                            {/* <ToggleButtonGroup style={styles.toggleButtonContainer}
                            sx={{
                                [theme.breakpoints.down('sm')]: {
                                    justifyContent: 'flex-start',
                                },
                            }}
                            value={view} exclusive onChange={handleViewChange} aria-label="course view">
                            <StyledToggleButton value="card" aria-label="card view" title="Card View"
                                sx={{
                                    padding: '5px',
                                    [theme.breakpoints.down('sm')]: {
                                        fontSize: '0.7rem'
                                    },
                                }}><DashboardIcon /></StyledToggleButton>
                            <StyledToggleButton value="grid" aria-label="grid view" title="Grid View"
                                sx={{
                                    padding: '5px',
                                    [theme.breakpoints.down('sm')]: {
                                        fontSize: '0.7rem'
                                    },
                                }}><GridViewIcon /></StyledToggleButton>
                        </ToggleButtonGroup> */}
                            <div style={styles.create}>
                                <Link
                                    component="button"
                                    variant="body2"
                                    onClick={() => navigate('/courses/create')}
                                    title='Create Course'
                                    sx={{
                                        background: 'transparent',
                                        color: 'var(--mui-palette-primary-button)',
                                        p: 0,
                                    }}
                                >
                                    {/* <AddCircleIcon sx={{ fontSize: '1.8rem', marginTop: '4px' }} /> */}
                                </Link>
                            </div>
                        </Box>
                    </Box>
                </div>



                <Box sx={{
                    clear: 'both',
                    width: '100%',
                    float: 'left',
                    mt: 2,
                    position: 'relative',
                    boxSizing: 'border-box',
                }}>
                    {/* {view === 'card' ? (
                    <Grid container sx={{ position: 'relative', zIndex: 1, marginLeft: '-8px', marginRight: '-8px', width: 'auto' }}>
                        {studentList.length > 0 ? studentList.map(student => (
                            <Grid item key={student.id} xs={12} sm={6} md={4} lg={3} sx={{ p: 1 }}>
                                <StudentCard student={student} />
                            </Grid>
                        )) : <NoStudent />}
                    </Grid>
                ) : ( */}
                    <Grid sx={styles.gridContainer} container spacing={2} mb={3} alignItems="center">
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <InputLabel style={styles.inputLabel}>Intelliread Level</InputLabel>
                            <FormControl fullWidth>
                                <Select
                                    name="irLevel"
                                    value={filterData?.irLevel || ''}
                                    onChange={(e) => handleChange(e)}
                                    placeholder="IR Level"
                                    sx={{ height: '47px' }}
                                >
                                    <MenuItem value=""><em>None</em></MenuItem>
                                    {studentConstant.IR_LEVELS?.map((item, index) => {
                                        return <MenuItem key={index} value={item}>{item}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <InputLabel style={styles.inputLabel}>Grade</InputLabel>
                            <FormControl fullWidth>
                                <Select
                                    name="grade"
                                    value={selectedGrade || {}}
                                    onChange={(e) => handleGradeChange(e)}
                                    placeholder="Grade"
                                    sx={{ height: '47px' }}
                                >
                                    <MenuItem value=""><em>None</em></MenuItem>
                                    {gradeList?.map((item, index) => {
                                        return <MenuItem key={index} value={item}>{item?.grade}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <InputLabel style={styles.inputLabel}>Section</InputLabel>
                            <FormControl fullWidth>
                                <Select
                                    name="section"
                                    value={selectedSection || {}}
                                    onChange={(e) => handleSectionChange(e)}
                                    placeholder="Section"
                                    sx={{ height: '47px' }}
                                >
                                    <MenuItem value=""><em>None</em></MenuItem>
                                    {sectionList?.map((item, index) => {
                                        return <MenuItem key={index} value={item}>{item.section}</MenuItem>
                                    })}
                                </Select>
                            </FormControl>
                        </Grid>

                    </Grid>
                    <div style={{ minHeight: 500, width: '100%', overflow: 'auto' }}>
                        <DataGrid
                            rows={getFilteredStudents()}
                            columns={columns}
                            disableRowSelectionOnClick
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 10,
                                    },
                                },
                            }}
                            has context menu
                            sx={{
                                backgroundColor: 'var(--mui-palette-common-white)',
                                [theme.breakpoints.down('sm')]: {
                                    width: '900px',
                                },
                                '& .css-yrdy0g-MuiDataGrid-columnHeaderRow': {
                                    background: 'var(--mui-palette-primary-blue) !important',
                                    color: 'var(--mui-palette-action-active)',
                                },
                                '& .MuiDataGrid-columnHeader': {
                                    background: 'var(--mui-palette-primary-blue) !important',
                                    color: 'var(--mui-palette-common-white)',
                                    '&:focus': {
                                        outline: 'none',
                                    }
                                },
                                '& .MuiDataGrid-columnHeaderTitle': {
                                    fontSize: '14px',
                                    fontWeight: 'bold',
                                },
                                '& .MuiSvgIcon-root': {
                                    color: 'var(--mui-palette-common-white)',
                                },
                                '& .MuiDataGrid-cell:focus': {
                                    outline: 'none',
                                    border: 'none',
                                },
                                '& .MuiSvgIcon-root': {
                                    color: 'black', // This changes the pagination arrow color
                                },
                            }}
                            pageSize={5} />
                    </div>
                    {/* )} */}

                    {/* <CoursePagination /> */}
                </Box>
            </div>
        }</>
    );

}

const styles = {
    toggleButtonContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    create: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '0',
        marginBottom: '0',
        marginLeft: '5px',
    },
    courses: {
        marginTop: '2rem'
    },
    label: {
        color: 'var(--mui-palette-common-black)',
        fontWeight: 'bold'
    },
    inputLabel: {
        color: 'var(--mui-palette-primary-darkGrey)',
        marginBottom: '5px',
        fontWeight: '600',
        fontSize: '14px'

    },
    gridContainer: {
        mb: 3
    },
    suggestionBox: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        marginTop: '10px',
    },
    suggestionItem: {
        padding: '10px',
        border: '1px solid #ccc',
        borderRadius: '2px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px var(--mui-palette-secondary-boxShadow1)',
        backgroundColor: 'var(--mui-palette-gray-lightGrey300)',
    },
    uploadBtn: {
        width: '50px',
        height: '50px',
        borderRadius: '5px',
    },
    hiddenInput: {
        display: 'none',
    }
};